/**
 * Apresentação ("Por que consórcio"): a leitura da proposta e as opções da
 * caixinha. A parte pura mora em db/supabase/functions/_shared/apresentacao/
 * (entrada.ts), que a North IA também usa; aqui fica só o que lê o banco pelo
 * cliente do navegador.
 */
import { supabase } from '@/components/atomic-crm/providers/supabase/supabase';
import type { Segmento } from './comparativo';
import { segmentoDaModalidade } from '../../../../../db/supabase/functions/_shared/apresentacao/entrada.ts';
import type { ProposalPayload } from './proposal-utils';

export * from '../../../../../db/supabase/functions/_shared/apresentacao/entrada.ts';

const num = (v: unknown): number | null => {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * Segmento da proposta: pela modalidade gravada no payload ou, nas propostas
 * que não a têm (North IA, registros antigos), pelo grupo. null quando não dá
 * para saber — aí a caixinha pede ao vendedor, em vez de chutar o segmento e
 * comparar imóvel com juros de carro.
 */
export const descobrirSegmento = async (payload: ProposalPayload): Promise<Segmento | null> => {
  const direto = segmentoDaModalidade(payload.modalidade);
  if (direto) return direto;
  const grupo = num(payload.groupNumber);
  if (grupo) {
    const { data } = await supabase.from('servopa_groups').select('segment').eq('group_number', grupo).maybeSingle();
    const doGrupo = segmentoDaModalidade((data as { segment?: string } | null)?.segment);
    if (doGrupo) return doGrupo;
  }
  return null;
};
